export default __webpack_public_path__ + "static/media/camera.3f533d89.svg";